<template>
    <div class="text-caption">
        <div :class="['d-flex align-center', schedule.activation.isScheduled || bothScheduled ? 'text-success' : 'red--text']">
            <v-icon class="calendar-setting">mdi-calendar-blank-outline</v-icon>
            <span class="mx-2">{{ activationSetting }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ActivationSetting',
    computed: {
        activationSetting() {
            const arr = [];

            if (this.schedule.activation.isScheduled) {
                arr[0] = `${this.schedule.activation.status} is scheduled on ${this.schedule.activation.datetime}`;
            }
            if (this.schedule.deactivation.isScheduled) {
                arr[1] = `${this.schedule.deactivation.status} is scheduled on ${this.schedule.deactivation.datetime}`;

                if (this.schedule.activation.isScheduled) {
                    arr[1] = this.$options.filters.lowercaseFirst(arr[1]);
                }
            }

            return arr.filter(Boolean).join(' and ');
        },
        bothScheduled() {
            return this.schedule.activation.isScheduled && this.schedule.deactivation.isScheduled;
        },
        schedule() {
            const merchantDetails = this.$store.getters['merchants/getMerchantDetails'];

            return merchantDetails.schedule || {};
        }
    }
};
</script>

<style lang="scss" scoped>
.calendar-setting {
    color: inherit;
    font-size: 14px;
}
</style>
